/**
 * SEO Structured Data Templates for ManageEcom
 * Use these for generating JSON-LD structured data across pages
 */

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "ManageEcom",
  "url": "https://www.manageecom.com",
  "logo": "https://manageecom.com/static/media/manageEcom-logo.c261db53d16211e297a0.png",
  "description": "ManageEcom provides comprehensive eCommerce management software for multi-channel inventory, order processing, and business management.",
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+91-7718895734",
    "contactType": "Customer Support",
    "email": "support@nuvio.in",
    "availableLanguage": ["English", "Hindi"]
  },
  "sameAs": [
    "https://www.facebook.com/manageecom",
    "https://twitter.com/manageecom",
    "https://www.linkedin.com/company/manageecom"
  ],
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "IN"
  }
};

export const softwareApplicationSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "ManageEcom",
  "applicationCategory": "BusinessApplication",
  "operatingSystem": "Web",
  "offers": {
    "@type": "Offer",
    "price": "500",
    "priceCurrency": "INR",
    "description": "Basic Plan - Inventory Management for 500 Units"
  },
  "description": "Multi-channel inventory management and order processing software for e-commerce businesses",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.5",
    "reviewCount": "150"
  }
};

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

export const articleSchema = (title, description, author, datePublished, dateModified, image) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": title,
  "description": description,
  "author": {
    "@type": "Person",
    "name": author
  },
  "datePublished": datePublished,
  "dateModified": dateModified,
  "image": image,
  "publisher": {
    "@type": "Organization",
    "name": "ManageEcom",
    "logo": {
      "@type": "ImageObject",
      "url": "https://manageecom.com/static/media/manageEcom-logo.c261db53d16211e297a0.png"
    }
  }
});

export const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "E-commerce Management Software",
  "provider": {
    "@type": "Organization",
    "name": "ManageEcom"
  },
  "areaServed": {
    "@type": "Country",
    "name": "India"
  },
  "description": "Multi-channel inventory management, order processing, and payment reconciliation services for e-commerce businesses"
};

export const contactPageSchema = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  "url": "https://www.manageecom.com/contact",
  "name": "Contact ManageEcom",
  "description": "Get in touch with ManageEcom for support and inquiries"
};

export const pricingSchema = (plans) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "ManageEcom Subscription",
  "description": "Multi-channel inventory management software subscription plans",
  "offers": plans.map(plan => ({
    "@type": "Offer",
    "name": plan.name,
    "price": plan.price,
    "priceCurrency": "INR",
    "description": plan.description
  }))
});

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "ManageEcom",
  "url": "https://www.manageecom.com",
  "description": "Multichannel listing and inventory management system for e-commerce businesses",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://www.manageecom.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};
